<template>
  <div class="px-5">
    <v-data-table :headers="headers" :items="userExpensesList" class="elevation-1">
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.name_user }}
          <br />
          <small>
            <b>Referência:</b>
            {{props.item.name_sis}}
          </small>
        </td>
        <td class="text-xs-left">
          {{ props.item.code_user }}
          <br />
          <small>
            <b>Cod. referência:</b>
            {{props.item.code_sis}}
          </small>
        </td>
        <td class="text-xs-center">
          <v-btn flat icon @click="openEditExpenseDialog(props.item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <!-- <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> -->
        </td>
      </template>
    </v-data-table>
    <EditExpense
      :getUserExpenses="getUserExpenses"
      :editExpenseDialog="editExpenseDialog"
      :expenseData="expenseData"
      :closeEditExpenseDialog="closeEditExpenseDialog"
    />
  </div>
</template>
<script>
import EditExpense from "./EditExpense";
export default {
  methods: {
    openEditExpenseDialog(data) {
      this.expenseData = data;
      this.editExpenseDialog = true;
    },
    closeEditExpenseDialog() {
      this.editExpenseDialog = false;
    }
  },
  components: {
    EditExpense
  },
  props: {
    userExpensesList: Array,
    getUserExpenses: Function
  },
  data() {
    return {
      expenseData: {},
      editExpenseDialog: false,
      headers: [
        {
          text: "Despesa",
          align: "left",
          sortable: false,
          value: "name_user"
        },
        {
          text: "Código da despesa",
          align: "left",
          sortable: false,
          value: "code_user"
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "acions"
        }
      ]
    };
  }
};
</script>